// ALL of this will be deleted once other configuration
export const USER_ID = 'SOME_NON_RANDOM_USER_ID';
export const USER_NAME = 'SOME_NON_RANDOM_NAME';
export const USER_LASTNAME = 'SOME_NON_RANDOM_LASTNAME';
export const USER_EMAIL = 'email@email.com';
